import {http} from "../utils/http";

export const getSystemAnalysisMeter = async (data) => {
    try {
        return await http.get("SystemAnalysis/meter", {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisMeterAlarm = async (data) => {
    try {
        return await http.get("SystemAnalysis/meter-alarm", {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisTransmission = async (data) => {
    try {
        return await http.get("SystemAnalysis/transmission", {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisConsumption = async (data) => {
    try {
        return await http.get("SystemAnalysis/consumption", {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisFlow = async (data) => {
    try {
        return await http.get("SystemAnalysis/flow", {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisIndividualMeterAlarm = async (serialNumber, data) => {
    try {
        return await http.get(`SystemAnalysis/meter-alarm/${serialNumber}`, {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisIndividualTransmission = async (serialNumber, data) => {
    try {
        return await http.get(`SystemAnalysis/transmission/${serialNumber}`, {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisIndividualConsumption = async (serialNumber, data) => {
    try {
        return await http.get(`SystemAnalysis/consumption/${serialNumber}`, {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisIndividualFlow = async (serialNumber, data) => {
    try {
        return await http.get(`SystemAnalysis/flow/${serialNumber}`, {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisMeterExcelData = async (data) => {
    try {
        return await http.get("SystemAnalysis/meter-all", {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisAlarmExcelData = async (data) => {
    try {
        return await http.get("SystemAnalysis/meter-alarm-all", {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisTransmissionExcelData = async (data) => {
    try {
        return await http.get("SystemAnalysis/transmission-all", {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisConsumptionExcelData = async (data) => {
    try {
        return await http.get("SystemAnalysis/consumption-all", {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisFlowExcelData = async (data) => {
    try {
        return await http.get("SystemAnalysis/flow-all", {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisIndividualMeterAlarmExcelData = async (serialNumber, data) => {
    try {
        return await http.get(`SystemAnalysis/meter-alarm-all/${serialNumber}`, {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisIndividualTransmissionExcelData = async (serialNumber, data) => {
    try {
        return await http.get(`SystemAnalysis/transmission-all/${serialNumber}`, {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisIndividualConsumptionExcelData = async (serialNumber, data) => {
    try {
        return await http.get(`SystemAnalysis/consumption-all/${serialNumber}`, {
            params: data,
        });
    } catch (error) {
    }
};

export const getSystemAnalysisIndividualFlowExcelData = async (serialNumber, data) => {
    try {
        return await http.get(`SystemAnalysis/flow-all/${serialNumber}`, {
            params: data,
        });
    } catch (error) {
    }
};
